export default class AddSchoolCommonRoomController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    SchoolCommonRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.SchoolCommonRoomService = SchoolCommonRoomService;

    this.schoolCommonRoom = {};
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    if (this.startTime) {
      this.schoolCommonRoom.workingHourStart = this.startTime;
    }

    if (this.endTime) {
      this.schoolCommonRoom.workingHourEnd = this.endTime;
    }

    this.SchoolCommonRoomService.add(this.schoolCommonRoom)
      .then(result => {
        this.$mdDialog.hide(result);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie dodano świetlicę')
            .position('bottom right')
            .hideDelay(3000)
        );
      }).catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}
